import { useQuery } from 'react-query';
import {
  getCastRelationshipById,
  type CastRelationshipResponse
} from '../../services/castRelationshipService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetCastRelationshipById(castRelationshipId: string) {
  return useQuery<CastRelationshipResponse, Error, CastRelationshipResponse>(
    SCENE_QUERY_KEYS.castRelationship(castRelationshipId),
    () => getCastRelationshipById({ castRelationshipId }),
    {
      enabled: !!castRelationshipId
    }
  );
}
